module.exports = __webpack_public_path__ + "img/20190529142623微信截图_20190529143011.3b2ef586.png";